const Const = {
  api_url: process.env.VUE_APP_BASE_API,
  cms_url: process.env.VUE_APP_CMS_URL
}

export const GROUP_LIMIT = 10
export const DEBOUNCE_INPUT = 1000

export const GET_ALL_LIMIT = 99999

export enum ERR_API_KEY {
  GROUP_NOT_FOUND = 'GROUP_NOT_FOUND',
  GROUP_IS_STOPPED = 'GROUP_IS_STOPPED',
  EXCEED_GROUP_STORAGE_CAPACITY = 'EXCEED_GROUP_STORAGE_CAPACITY',
  EXCEED_COMPANY_STORAGE_CAPACITY = 'EXCEED_COMPANY_STORAGE_CAPACITY',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INVALID_USER = 'INVALID_USER',
  INVALID_TOKEN = 'INVALID_TOKEN',
  REFRESH_TOKEN_EXPIRED = 'REFRESH_TOKEN_EXPIRED',
  REFRESH_TOKEN_INVALID = 'REFRESH_TOKEN_INVALID',
  USER_NOT_BE_LONG_TO_GROUP = 'USER_NOT_BE_LONG_TO_GROUP',
  USER_NOT_BE_LONG_TO_COMPANY = 'USER_NOT_BE_LONG_TO_COMPANY',
  USER_NOT_BELONG_TO_COMPANY = 'USER_NOT_BELONG_TO_COMPANY',
  EMAIL_NOT_FOUND = 'EMAIL_NOT_FOUND',
  MAIL_NOT_REGISTERED = 'MAIL_NOT_REGISTERED',
  MAIL_IN_TEMP_REGISTRATION = 'MAIL_IN_TEMP_REGISTRATION',
  MAIL_PENDING_GROUP_ADMIN_APPROVAL = 'MAIL_PENDING_GROUP_ADMIN_APPROVAL',
  MAX_TOTAL_FILE_SIZE = 'MAX_TOTAL_FILE_SIZE',
  USER_MAX_UPLOAD_SIZE_IN_CHAT = 'USER_MAX_UPLOAD_SIZE_IN_CHAT',
  SEND_MESSAGE_DENIED = 'SEND_MESSAGE_DENIED',
  USER_NO_EXIST_GENERAL_GROUP_TAG = 'USER_NO_EXIST_GENERAL_GROUP_TAG',
  UPDATE_GROUP_HAS_NO_ADMIN = 'UPDATE_GROUP_HAS_NO_ADMIN',
  FILE_HISTORY_NOT_FOUND = 'FILE_HISTORY_NOT_FOUND',
  CURRENT_PASSWORD_NOT_MATCH = 'CURRENT_PASSWORD_NOT_MATCH',
  CURRENT_PASSWORD_AND_NEW_PASSWORD_CAN_NOT_SAME = 'CURRENT_PASSWORD_AND_NEW_PASSWORD_CAN_NOT_SAME',
  INVALID_USER_STATUS = 'invalid_user_status',
  USER_HAS_BEEN_LOCKED = 'user_has_been_locked',
  GROUP_NOT_FOUND_OR_STOPPED = 'GROUP_NOT_FOUND_OR_STOPPED',
  UPDATE_FROM_INVITE_LINK_FAIL = 'UPDATE_FROM_INVITE_LINK_FAIL',
  WAIT_FOR_APPROVAL = 'WAIT_FOR_APPROVAL',
  NOT_CHANGE_COMPANY = 'NOT_CHANGE_COMPANY',
  INVALID_MEMBER_STATUS = 'INVALID_MEMBER_STATUS',
  INVALID_MEMBER_IN_INVITE_LIST = 'INVALID_MEMBER_IN_INVITE_LIST',
  TOPIC_HAS_BEEN_DELETED = 'TOPIC_HAS_BEEN_DELETED',
  TOPIC_NOT_FOUND = 'TOPIC_NOT_FOUND',
  COMMENT_NOT_FOUND = 'COMMENT_NOT_FOUND',
  FOLDER_NOT_EXIST = 'FOLDER_NOT_EXIST',
  FOLDER_NOT_FOUND = 'FOLDER_NOT_FOUND',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  DEVICE_RETWEET = 'DEVICE_RETWEET',
  LOCKED_BY_OTHER_USER = 'locked_by_other_user',
  USER_IS_ONLY_GROUP_ADMIN_EXIST = 'USER_IS_ONLY_GROUP_ADMIN_EXIST',
  ITEM_EXISTS_THAT_IS_NOT_INFORMATION = 'ITEM_EXISTS_THAT_IS_NOT_INFORMATION', // unused
  NOT_HAVE_EMAIL_TO_LOGIN = 'NOT_HAVE_EMAIL_TO_LOGIN', // unused
  NOT_FOUND_EMAIL_IN_SYSTEM = 'NOT_FOUND_EMAIL_IN_SYSTEM', // unused

  //TRANSLATION
  TOO_MANY_SEGMENTS = 'TOO_MANY_SEGMENTS',
  GOOGLE_TRANSLATE_API_ERROR = 'GOOGLE_TRANSLATE_API_ERROR',

  // LOGIN AUTHORIZE
  LOGIN_AUTHORIZED_EMAIL = 'login_authorized_email',
  LOGIN_AUTHORIZED_EMPLOYEE_ID = 'login_authorized_employee_id',
  USER_NOT_FOUND = 'USER_NOT_FOUND', // unused
  ACCESS_DENIED_BY_IP_RESTRICTION = 'ACCESS_DENIED_BY_IP_RESTRICTION', // unused

  ERROR_MAX_REGISTERED_USER = 'error_max_registered_user',
  USE_HAS_BEEN_UPDATED = 'use_has_been_updated',

  NEEDS_ACCEPTANCE = 'NEEDS_ACCEPTANCE',

  // PERMISSION_DENIED
  PERMISSION_DENIED_COMMENT = 'PERMISSION_DENIED_COMMENT'
}

export enum TRANSLATION_TYPE {
  SYSTEM_NEWS = 1,
  CALENDAR = 2,
  CHAT = 3,
  GROUP_NOTICE = 4,
  TOPIC = 5,
  TOPIC_COMMENT = 6,
  TOPIC_SHARED_FOLDER = 7
}

export const MAX_USER_DISPLAY = 10

export default Const

export const PUSH_NOTIFICATION_NOT_IS_SEEN = 0
export const FROM_DEVICE_WEB = 2
